import { Center, Spinner } from '@chakra-ui/react';
import { Redirect, useLocation } from 'react-router-dom';

import { DefaultOnboardingRoutes } from 'apps/customer/routes/paths';
import SignUpRoutes from 'apps/customer/routes/SignUpRoutes';
import { isTreatmentOnlySignInOnboardingPath } from 'apps/customer/utils/signInOnboardingPathGate';

import SignInOnboardingContainer from './SignInOnboardingContainer';

import type { SignInOnboardingExperimentState } from './useSignInOnboardingExperiment';

export default function SignInOnboardingGate({
  experiment,
}: {
  experiment: SignInOnboardingExperimentState;
}) {
  const location = useLocation();

  if (experiment.status === 'pending') {
    return (
      <Center minH="100dvh">
        <Spinner />
      </Center>
    );
  }

  if (experiment.status === 'control' && isTreatmentOnlySignInOnboardingPath(location.pathname)) {
    return <Redirect to={DefaultOnboardingRoutes.SignIn + location.search} />;
  }

  return experiment.status === 'treatment' ? <SignInOnboardingContainer /> : <SignUpRoutes />;
}
